

class NamedFormula
{
	constructor(input)
	{
		this.formula_uuid = ko.observable();
		this.name = ko.observable();
		this.schema = ko.observable();
		this.formula = ko.observable();
		this.namespace = ko.observable();
		this.description = ko.observable();

		if (input)
			this.set(input);
	}

	set(input)
	{
		this.formula_uuid(input.formula_uuid);
		this.name(input.name);
		this.schema(input.schema);
		this.formula(input.formula);
		this.namespace(input.namespace);
		this.description(input.description);
	}
}

class Function
{
	constructor(input)
	{
		this.function_uuid = ko.observable();
		this.return_basetype = ko.observable();
		this.function_name = ko.observable();
		this.description = ko.observable();
		this.is_immutable = ko.observable();
		this.is_protected = ko.observable(false);
		this.tooltip = ko.observable('');
		this.title = ko.observable('');
		this.params = ko.observableArray([]);

		if (input)
			this.set(input);

	}

	set(input)
	{
		this.function_uuid(input.function_uuid);
		this.return_basetype(input.return_basetype);
		this.function_name(input.function_name);
		this.description(input.description);
		this.is_immutable(input.is_immutable);
		this.is_protected(input.is_protected);
		this.tooltip(input.tooltip);
		this.title(input.tooltip + ' - ' + input.description);

		let params = [];

		for (let param of input.params)
			params.push(new FunctionParameter(param));

		this.params(params);
	}
}

class FunctionParameter
{
	constructor(input)
	{
		this.idx = ko.observable();
		this.name = ko.observable();
		this.description = ko.observable();
		this.basetype = ko.observable();
		this.is_variadic = ko.observable();
		this.is_optional = ko.observable();

		if (input)
			this.set(input);
	}

	set(input)
	{
		this.idx(input.idx);
		this.name(input.name);
		this.description(input.description);
		this.basetype(input.basetype);
		this.is_variadic(input.is_variadic);
		this.is_optional(input.is_optional);
	}
}

class Formula
{
	constructor(input)
	{
		this.formula_uuid = ko.observable(null);
		this.function_name = ko.observable(null);
		this.function_uuid = ko.observable(null);
		this.parameters = ko.observableArray([]);

		this.is_set = ko.observable(false);

		if(input)
			this.set(input);

		this.definition = ko.computed(() => {

			let temp_text = this.function_name() + '(';
			for (const param of this.parameters())
			{
				if (param.parameter_type() === 'value' && param.parameter_value())
				{
					temp_text += param.parameter_value();
				} else if (param.parameter_type() === 'context')
				{
					temp_text += 'CTX(';
					if (param.context_selector())
						temp_text += ('"' + param.context_selector() + '"');
					temp_text += ')';
				} else if (param.parameter_type() === 'formula') 
				{
					temp_text += param.formula().definition();
				}
				temp_text += ',';
			}
			if (temp_text.endsWith(','))
				temp_text = temp_text.slice(0,-1); 

			temp_text += ')';

			return temp_text;
		});
	}

	set(input)
	{
		this.formula_uuid(input.formula_uuid);
		this.function_name(input.function_name);
		this.function_uuid(input.function_uuid);
			
		let params = [];
		for (const param of (input.parameters ?? []))
			params.push(new Parameter(param));
		this.parameters(params);

		this.is_set(true);
	}
}

class Parameter 
{
	constructor(input)
	{
		this.idx = ko.observable();
		this.parameter_type = ko.observable();

		this.formula = ko.observable(null);
		this.context_selector = ko.observable(null);
		this.parameter_value = ko.observable(null);

		if (input)
			this.set(input);
	}
	
	set(input)
	{
		this.idx(input.idx);
		this.parameter_type(input.parameter_type);

		switch (input.parameter_type)
		{
			case 'formula':
				this.formula(new Formula(input));
				this.context_selector(null);
				this.parameter_value(null);
				break;
			case 'context':
				this.formula(new Formula());
				this.context_selector(input.context_selector);
				this.parameter_value(null);
				break;
			case 'value':
				this.formula(new Formula());
				this.context_selector(null);
				this.parameter_value(typeof input.parameter_value === 'string' ? '"' + input.parameter_value + '"' : input.parameter_value);
				break;
		}
	}
}

export default {
	NamedFormula,
	Formula,
	Parameter,
	Function,
	FunctionParameter
}
